import { FC } from 'react'
import { IUserBase } from '@/types'
import { NoContent } from '@/components/atoms/NoContent'
import { JobSeekerCard } from '@/components/molecules/JobSeekerCard'
import styles from './index.module.scss'

type Props = {
  items: IUserBase[]
}

export const JobSeekerCardList: FC<Props> = ({ items = [] }) => {
  if (items.length === 0) {
    return <NoContent>Expert is not registered yet.</NoContent>
  }

  return (
    <div className={styles.container}>
      {items.map((item) => {
        return (
          <div key={item.username} className={styles.item}>
            <JobSeekerCard item={item} />
          </div>
        )
      })}
    </div>
  )
}
